<template>
  <div>
    <b-alert
      show
      variant="danger"
      class="custom-alert mb-0 p-2"
      dismissible
      fade
    >
      <h4 class="alert-heading font-weight-normal">Attention</h4>
      <div class="alert-body">
        <feather-icon class="mr-25" icon="StarIcon" />
        <small class="ml-25">This tabel will update every 15 minutes.</small>
        <br />
        <feather-icon class="mr-25" icon="StarIcon" />
        <small class="ml-25">The following data may have a 15% mistake.</small>
      </div>
    </b-alert>

    <data-table :fields="fields" :items="openTrades" :loading="loading">
      <template #user="{ data }">
        <b-avatar rounded :src="data.item.avatar" class="mr-1"> </b-avatar>
        <span>
          {{ data.item.name }}
        </span>
      </template>
      <template #symbol="{ data }">
        <b-avatar :text="data.item.symbol" variant="warning" class="mr-1">
        </b-avatar>
        <span>
          {{ data.item.symbol || "-" }}
        </span>
      </template>
      <template #type="{ data }">
        <b-badge
          :variant="data.item.type == 'sell' ? 'light-danger' : 'light-success'"
        >
          {{ data.item.type }}
        </b-badge>
      </template>
      <template #lot="{ data }">
        {{ data.item.lot == 0 ? 0 : data.item.lot || "-" }}
      </template>
      <template #open_price="{ data }">
        {{ data.item.open_price == 0 ? 0 : data.item.open_price || "-" }}
      </template>
      <template #close_price="{ data }">
        {{ data.item.close_price == 0 ? 0 : data.item.close_price || "-" }}
      </template>
      <template #take_profit="{ data }">
        {{ data.item.take_profit == 0 ? 0 : data.item.take_profit || "-" }}
      </template>
      <template #stop_loss="{ data }">
        {{ data.item.stop_loss == 0 ? 0 : data.item.stop_loss || "-" }}
      </template>
    </data-table>
  </div>
</template>
<script>
import {
  BButton,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  BAlert,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    BAlert,
  },

  data() {
    return {
      loading: false,
      fields: [
        { key: "user", label: "user" },
        { key: "symbol", label: "symbol" },
        { key: "type", label: "type" },
        { key: "lot", label: "lot" },
        { key: "open_price", label: "open price" },
        { key: "close_price", label: "close price" },
        { key: "take_profit", label: "take profit" },
        { key: "stop_loss", label: "stop loss" },
      ],
      openTrades: [],
      tempOpenTrades: [],
      interval: "",
      search: "",
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  async created() {
    this.loading = true;
    await this.getOpenTrades();
    this.loading = false;
    this.interval = setInterval(async () => {
      this.getOpenTrades();
    }, 120000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    async search(val) {
      if (!val) {
        this.loading = true;
        this.openTrades = await this.tempOpenTrades;
        this.loading = false;
      } else {
        this.onSearch();
      }
    },
  },
  methods: {
    async onSearch() {
      this.loading = true;
      this.openTrades = await this.tempOpenTrades;
      this.openTrades = await this.openTrades.filter(
        (item) =>
          item.name.toLowerCase().includes(this.search.toLowerCase()) ||
          item.type.toLowerCase().includes(this.search.toLowerCase()) ||
          item.symbol.toLowerCase().includes(this.search.toLowerCase())
      );
      this.loading = false;
    },
    async getOpenTrades(page) {
      try {
        page && (params.page = page);
        const { data } = await this.$http.get(
          Object.keys(this.userData).length
            ? `/panel/competitions/${this.$route.params.id}/open-trades`
            : `/competitions/${this.$route.params.id}/open-trades`
        );
        this.openTrades = data;
        this.tempOpenTrades = data;
      } catch (err) {}
    },
  },
};
</script>
